import apiCallTemplate from './servicesConfig'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const authURL = `${BASE_URL}/users`;

//Login
export const login=async (data)=>apiCallTemplate("post", `${authURL}/login`, data,)

//Register
export const register=async (data)=>apiCallTemplate("post", `${authURL}/register`, data,)

//Forget Password
export const generateOtp=async (data)=>apiCallTemplate("post", `${authURL}/generate-otp`, data)

//Forget Password
export const resetPassword=async (data)=>apiCallTemplate("post", `${authURL}/password/reset`, data)

//Update Password
export const updatePassword=async (data)=>apiCallTemplate("post", `${authURL}/update/password`, data,)

//Update Email
export const updateEmail=async (data)=>apiCallTemplate("put", `${authURL}/change/email`, data,)
